import React, { useState } from 'react';

// Hardcoded "DB"
const projects = [
  {
    name: 'InkSpire',
    logo: '/assets/inkspire.png',
    desc: [
      'IoT platform for ESP32 e-paper displays with environmental sensors',
      'Real-time weather, traffic, credit card tracking & AI quotes',
      'Embedded firmware with temperature, humidity, air quality & GPS tracking'
    ],
    tech: ['C++', 'PlatformIO', 'ESP32', 'FastAPI', 'React', 'TypeScript', 'SQL Server', 'OpenAI', 'Google Maps API', 'AWS SES', 'DHT22', 'BME680', 'GPS', 'AWS EC2'],
    categories: ['IoT', 'Embedded', 'Web App'],
    domain: 'IoT',
    live: 'https://inkspire.codetrend.com',
    github: 'https://github.com/codetrend-mx/inkspire'
  },
  {
    name: 'VPTS',
    logo: '/assets/vinyl-record.png',
    desc: [
      'Vinyl Production Tracking System',
      'Multi-stage workflow management for vinyl manufacturing',
      'End-to-end production pipeline from request to shipping'
    ],
    tech: ['React 19', 'Material-UI', 'ASP.NET Core 9', 'SQL Server', 'JWT Auth', 'AWS EC2'],
    categories: ['Web App'],
    domain: 'Manufacturing',
    live: 'https://vpts.codetrend.com',
    github: 'https://github.com/codetrend-mx/vpts-web'
  },
  {
    name: 'VPTS AI',
    logo: '/assets/vpts-ai.png',
    desc: [
      'AI-powered production assistant with RAG',
      'Real-time insights using Semantic Kernel & vector DB',
      'Intelligent query system for vinyl manufacturing data'
    ],
    tech: ['Next.js 15', 'React 19', '.NET 9', 'Semantic Kernel', 'OpenAI', 'Ollama', 'ChromaDB'],
    categories: ['AI'],
    domain: 'Manufacturing',
    live: 'https://vpts-ai.codetrend.com',
    github: 'https://github.com/codetrend-mx/vpts-ai'
  },
  {
    name: 'VPTS Analytics',
    logo: '/assets/vpts-analytics.png',
    desc: [
      'Data warehouse analytics dashboard',
      'Real-time production metrics & KPIs',
      'Interactive visualizations for business intelligence'
    ],
    tech: ['React 19', 'Vite', 'Material-UI', 'Recharts', '.NET 9', 'Dapper', 'SQL Server DW'],
    categories: ['Analytics'],
    domain: 'Manufacturing',
    live: 'https://vpts-analytics.codetrend.com',
    github: 'https://github.com/codetrend-mx/vpts-analytics'
  },
  {
    name: 'DecodeRx',
    logo: '/assets/decoderx.png',
    desc: [
      'Drug info retriever powered by GPT',
      'Pill scanner, voice search, OpenAI summaries',
      'Healthcare professionals & patient assistance tool'
    ],
    tech: ['GPT-4 Vision', 'Whisper', 'OpenAI', 'Flask', 'AWS'],
    categories: ['AI'],
    domain: 'Healthcare',
    live: 'https://api.codetrend.com/decoderx',
    github: 'https://github.com/codetrend-mx/decoderx-api'
  },
  {
    name: 'HeartWave',
    logo: '/assets/heartwave.png',
    desc: [
      'Analyze heart sounds with AI',
      'Includes waveform display & diagnostic summary',
      'Non-invasive cardiac analysis prototype'
    ],
    tech: ['Librosa', 'Flask', 'OpenAI','Mathploit', 'Three.js', 'Azure'],
    categories: ['AI'],
    domain: 'Healthcare',
    live: 'https://api.codetrend.com/heartwave',
    github: 'https://github.com/codetrend-mx/heartwave-api'
  },
  {
    name: 'MoleScope AR',
    logo: '/assets/molescope.png',
    desc: [
      'AR molecule viewer + AI explanation',
      'Scan QR, explore, and learn interactively',
      'Educational tool for pharmaceutical research'
    ],
    tech: ['Hugging Face', 'WebXR', 'Three.js', 'PubChem API', 'React', 'Google Cloud'],
    categories: ['AR'],
    domain: 'Pharma',
    live: 'https://molescope.codetrend.com',
    github: 'https://github.com/codetrend-mx/molescope-web'
  },
  {
    name: 'CubitsAtWork',
    logo: '/assets/cubitsatwork.png',
    desc: [
      'AI-powered quantum circuit generator',
      'Natural language → circuits, images, explanations and simulations',
      'Multi-input (text, images, templates), exportable and visually rich results'
    ],
    tech: ['React', 'Vite', 'TypeScript', 'FastAPI', 'OpenCV', 'Qiskit', 'Matplotlib', 'IBM Cloud'],
    categories: ['Quantum'],
    domain: 'Quantum Computing',
    live: 'https://cubits.codetrend.com',
    github: 'https://github.com/codetrend-mx/cubits-web'
  },
  {
    name: 'QReel',
    logo: '/assets/qreel.png',
    desc: [
      'Quantum-inspired movie search experience',
      'Simulates Grover algorithm to boost relevance',
      'Filter by title, actor, plot, quotes — with AI-enhanced suggestions'
    ],
    tech: ['FastAPI', 'React', 'TMDb API', 'OpenAI', 'Grover-inspired Search Engine'],
    categories: ['Quantum'],
    domain: 'Entertainment',
    live: 'https://qreel.codetrend.com',
    github: 'https://github.com/codetrend-mx/qreel-web'
  }
];

const domains = ['All', 'IoT', 'Manufacturing', 'Healthcare', 'Pharma', 'Entertainment', 'Quantum Computing'];

export default function Projects() {
  const [selectedDomain, setSelectedDomain] = useState('All');

  const filteredProjects = projects.filter(p =>
    selectedDomain === 'All' || p.domain === selectedDomain
  );

  return (
    <div className="container py-5">
      <h2 className="mb-4">🚀 Featured Projects</h2>
      <p className="mb-4">
        These PoCs demonstrate my approach to solving complex problems through innovative technology — from LLMs and quantum search to AR and more.
      </p>

      {/* Filter aligned left */}
      <div className="mb-4">
        <label className="fw-bold me-2">Filter by Domain:</label>
        <select
          value={selectedDomain}
          onChange={e => setSelectedDomain(e.target.value)}
          className="form-select w-auto d-inline-block"
        >
          {domains.map(domain => <option key={domain}>{domain}</option>)}
        </select>
      </div>

      {/* Horizontal carousel */}
      <div className="d-flex overflow-auto gap-4 py-2">
        {filteredProjects.map((p, i) => (
          <div className="card shadow" key={i} style={{ minWidth: '300px', maxWidth: '300px' }}>
            <div className="project-img-container">
              <img src={p.logo} alt={p.name} className="project-logo" />
            </div>
            <div className="card-body">
              <h5 className="card-title fw-bold">{p.name}</h5>
              <ul className="list-unstyled">
                {p.desc.map((d, j) => <li key={j} className="mb-2">• {d}</li>)}
              </ul>
              <div className="mt-3 mb-2">
                {p.tech.map((t, k) => (
                  <span key={k} className="tech-badge dev me-1 mb-1">{t}</span>
                ))}
              </div>
              <div className="mb-2">
                {p.categories.map((c, k) => (
                  <span key={k} className="badge bg-secondary me-1">{c}</span>
                ))}
              </div>
            </div>
            <div className="card-footer d-flex justify-content-between bg-white border-0">
              <a href={p.live} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-play-fill"></i> Try it Live
              </a>
              <a href={p.github} className="btn btn-outline-dark" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-github"></i> Code
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
